import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import BreadCrumbs from "../../components/Breadcrumbs";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import UpdateProfileModal from "../../components/Modal/UpdateProfileModal/UpdateProfileModal";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/actions/actions";
import { setProfile } from "../../redux/actions/cartActions";
import ProfileItems from "./ProfileItems";
import ProgressBar from "../../components/DashboardMain/ProgressBar/ProgressBar";
import ProgressBarProfile from "../../components/DashboardMain/ProgressBar/ProgressBarProfile";
import BarFirst from "../../components/Profile/Bars/BarFirst";
import AgencyBadgeCard from "../../components/DynamicBadge/AgencyBadgeCard";
import { useTranslation } from "react-i18next";

export default function Profile() {
  const initialState = {
    phone: "",
    username: "",

    tax_address: "",
    tax_office: "",
    agent_name: "",
    address: "",
    tax_number: "",
    tax_name: "",
    id: null,
  };
  const { t } = useTranslation();

  const [loader, setLoader] = useState(true);
  const [formValues, setFormValues] = useState(initialState);
  const dispatch = useDispatch();
  const [response, setResponse] = useState(null);

  const getProfile = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    try {
      setLoader(true);
      // GET isteği yapılacak URL
      let url;
      url = `${process.env.REACT_APP_BASE_URL}auth/profile`;

      // Axios ile GET isteği yapılıyor
      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer token
          XRefreshToken: `${token}`, // XRefreshToken
          "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
        },
      });
      const profileData = response?.data?.profile;
      dispatch(setProfile(profileData));
      localStorage.setItem("profile", JSON.stringify(profileData));
      setFormValues((prev) => ({
        ...prev,
        phone: profileData?.phone,
        username: profileData?.username,
        tax_address: profileData?.tax_address,
        tax_office: profileData?.tax_office,
        agent_name: profileData?.agent_name,
        address: profileData?.address,
        tax_number: profileData?.tax_number,
        tax_name: profileData?.tax_name,
        id: profileData?.id,
      }));
      setLoader(false);
    } catch (error) {
      console.error("Error fetching dataaaa:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  // useEffect(() => {
  //   console.log(formValues, "here form values");
  // }, [formValues]);

  const handleOpenModal = (formValues, setFormValues) => {
    // Dispatch an action to open the modal, with the FilterModal component as the payload
    dispatch(
      openModal(
        <UpdateProfileModal
          formValues={formValues}
          setFormValues={setFormValues}
          getProfile={getProfile}
        />,
        "updateProfile"
      )
    );
  };

  return (
    <>
      {loader ? (
        <CircularProgress
          sx={{ position: "absolute", top: "50%", left: "50%" }}
        />
      ) : (
        <Box>
          <Typography className="title" variant="h4">
            {t("profile")}
            <StyledTitleDot />
          </Typography>
          <BreadCrumbs routs={[t("profile")]} />
          <Box sx={{ marginTop: "3rem" }}>
            {/* Agency Badge (feature: agency_commission_badges) */}
            <Grid container spacing={3} sx={{ marginBottom: "3rem" }}>
              <Grid item xs={12} md={12} lg={6}>
                <AgencyBadgeCard />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <ProgressBarProfile
                barType="profile"
                response={response}
                setResponse={setResponse}
              />
            </Grid>
            {response ? (
              <Grid container spacing={3} sx={{ marginBottom: "3rem" }}>
                <Grid item xs={12} md={12} lg={4}>
                  <Card
                    sx={{
                      borderRadius: "1rem",
                      padding: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BarFirst
                      barType={"default"}
                      response={response}
                      setResponse={setResponse}
                    />
                  </Card>
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                  <Card
                    sx={{
                      borderRadius: "1rem",
                      padding: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BarFirst
                      barType={"amount"}
                      response={response}
                      setResponse={setResponse}
                    />
                  </Card>
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                  <Card
                    sx={{
                      borderRadius: "1rem",
                      padding: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BarFirst
                      barType={"weeks"}
                      response={response}
                      setResponse={setResponse}
                    />
                  </Card>
                </Grid>
              </Grid>
            ) : null}
            <Grid container spacing={3}>
              <ProfileItems
                formValues={formValues}
                setFormValues={setFormValues}
              />

              <Grid item xs={12} sm={6} lg={4} xl={3}>
                <Button
                  fullWidth
                  sx={{ height: "100%", textTransform: 'capitalize' }}
                  onClick={() => handleOpenModal(formValues, setFormValues)}
                  variant="contained"
                >
                  {t("update")}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}
